import { render, staticRenderFns } from "./Item58AbamaRequestReservation.vue?vue&type=template&id=4c6e81c0&"
import script from "./Item58AbamaRequestReservation.vue?vue&type=script&lang=js&"
export * from "./Item58AbamaRequestReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports